import { KeyValue, KeyValueStateManager } from '../utils/keyValue';
import { UserKeyValueStore } from './userKeyStore';

export const userKeyStore = new KeyValue('UserValues', new UserKeyValueStore());
export const sessionKeyStore = new KeyValue('SessionValues');
export const userKeyStoreState = KeyValueStateManager(userKeyStore);
